/**
 * Micromark extension for <<variable>> / <<glossary:term>> inline syntax.
 */
export { legacyVariable } from './syntax';
